<div class="pusher" id="MainContaier">
  <div id="SecondaryContainer">
    <div style="margin: 10px">
      <!-- Progress Bar      -->
      <div [hidden]="!graphicHidden" style="margin-bottom: 10px">
        <p-progressBar mode="indeterminate"></p-progressBar>
      </div>
      <!-- Resource DropDown    -->
      <div class="dropDowns">
        <div class="select">
          <h4>Select Resource</h4>
        </div>
        <div class="floatRight">
            <p-dropdown 
            [(ngModel)]="resource" 
            [options]="resources"
            (onChange)="resourceSelected(dt);"
            [style]="{'width':'160px'}" 
            placeholder="Select Resource">
          </p-dropdown>
        </div>
      </div>
      <!-- Location DropDown -->
      <div class="dropDowns">
        <div class="select">
          <h4>Select Location</h4>
        </div>
        <div class="floatRight">
          <p-dropdown #dd (onChange)="filterLocation(dt);" [(ngModel)]="selectedLocation" [disabled]="locationsBlock"
            [options]="locationsDropDown" [style]="{'width':'160px'}" filter="true" id="locDropDown"
            placeholder="Select Location"></p-dropdown>
        </div>
      </div>
      <div>
        <!-- Option buttons for table -->
        <div style="float: right" class="fullfilters">
          <button (click)="onFilterButtonClick()" [disabled]="enableButtons" class="hidebutton" icon="pi pi-filter-fill"
            iconPos="left" label="{{filters}}" pButton type="button">
          </button>
          <button (click)="display =!display" [disabled]="enableButtons" class="hidebutton" icon="pi pi-file"
            iconPos="left" label="Export to CSV" pButton type="button">
          </button>
          <button (click)="refreshTable()" [disabled]="enableButtons" icon="pi pi-refresh" iconPos="left"
            label="Refresh Data" pButton type="button">
          </button>
        </div>
        <div style="float: right" class="shortfilters">
          <button (click)="onFilterButtonClick()" [disabled]="enableButtons" class="hidebutton" icon="fa-filter"
            iconPos="left" pButton type="button">
          </button>
          <button (click)="display =!display" [disabled]="enableButtons" class="hidebutton" icon="fa-file-o"
            iconPos="left" pButton type="button">
          </button>
          <button (click)="refreshTable()" [disabled]="enableButtons" icon="fa-refresh" iconPos="left" pButton type="button">
          </button>
        </div>
        <!-- Table Area -->
        <div>
          <h3> Robot Job Dashboard<span *ngIf="this.resource">: List of Jobs in</span> {{ resource }}
            {{selectedLocation}} </h3>
          <h3 *ngIf="this.resource&&!this.selectedLocation"> Select Location </h3>
          <p-table #dt (onLazyLoad)="loadJobsLazy($event)" (onRowSelect)="goDetails($event)" [(selection)]="selectedJob"
            [columns]="csvCols" [first]="firstOnTable" [lazy]="true" [loading]="loading" [paginator]="true"
            [rowHover]="true" [rowsPerPageOptions]="[50,100,150]" [rows]="50" [totalRecords]="totalRecords"
            [value]="jobs" selectionMode="multiple" styleClass="text-center">
            <ng-template let-columns pTemplate="header">
              <tr>
                <th *ngFor="let col of cols; let i = index" [ngStyle]="{'width': col.width}" [ngSwitch]="col.field" class="priority-{{i+1}}" id="{{i+1}}">
                  <span>{{col.header}}</span>
                  <p-sortIcon [field]="col.field" [hidden]="isFilterApp" [pSortableColumn]="col.field"></p-sortIcon>
                  <p-multiSelect #ms (onChange)=" dt.filter(selectedAppFullName,'application', 'in' );"
                    *ngSwitchCase="'entry'" [(ngModel)]="selectedAppFullName" [displaySelectedLabel]="true"
                    [hidden]="isFilterApp" [options]="applications" [panelStyle]="{minWidth:'12em'}"
                    [style]="{'width':'100%', 'height': '100%' }" defaultLabel="Choose application" filter="true"
                    overlayVisible="true">
                  </p-multiSelect>
                  <input *ngSwitchCase="'jobName'" pInputText type="text"
                    (input)="dt.filter(selectedJobName, 'jobName', 'in')" [(ngModel)]="selectedJobName"
                    [hidden]="isFilterApp" [style]="{'width':'100%', 'height': '100%' }" defaultLabel="Choose job name"
                    filter="true" overlayVisible="true">
                  <p-multiSelect #ms2 (onChange)=" dt.filter(selectedStatus,'status', 'in')" *ngSwitchCase="'status'"
                    [(ngModel)]="selectedStatus" [hidden]="isFilterApp" [options]="statusOptions"
                    [style]="{'width':'100%','height': '100%'}" id="rembold" showToggleAll="false" styleClass="multi">
                  </p-multiSelect>
                  <div>
                    <p-calendar (onClearClick)="dt.filter(null,'startTimestampUtc', 'contains')"
                      (onSelect)="dt.filter(selectedStartDate,'startTimestampUtc', 'contains')" *ngSwitchCase="'start'"
                      [(ngModel)]="selectedStartDate" [hidden]="isFilterApp" [showButtonBar]="true" [utc]="true"
                      dateFormat="dd/mm/yy">
                      <p-header> Dates are shown in UTC</p-header>
                      <p> UTC dates</p>
                    </p-calendar>
                  </div>
                </th>
              </tr>
            </ng-template>
            <ng-template let-columns="csvCols" let-rowData pTemplate="body">
              <tr>
                <td (click)="goDetails(rowData)" *ngFor="let col of cols; let i = index" class="priority-{{i+1}}">
                  <!-- Entry  Column  -->
                  <span *ngIf="col.field === 'entry'">{{rowData['description']}}</span>
                  <!-- Job Name  -->
                  <span *ngIf="col.field === 'jobName'">{{rowData['jobName']}}
                  </span>
                  <!-- Status Column  -->
                  <span *ngIf="col.field === 'status'">
                    <div [style.color]="statusHandler(rowData['status'])"> {{rowData['status']}}
                      <i [ngClass]="statusIconHandler(rowData['status'])"></i>
                    </div>
                  </span>
                  <!-- Start Column  -->
                  <span *ngIf="col.field === 'start'"
                    [title]="'Robot: '+ rowData['startTimestamp'] + ' , '+rowData['timeZone'] ">
                    {{convertDate(rowData['startTimestampUtc']) }} </span>
                  <!-- Average Column  -->
                  <span *ngIf="col.field === 'percentage'">
                    <div [style.background]="calculateColor(rowData['runTime'],
                      rowData['averageTime']) ? 'indianred' : null" [style.color]="calculateColor(rowData['runTime'],
                      rowData['averageTime']) ? 'white' : null" [title]="rowData['description']">
                      {{calculateDeviation(rowData['status'], rowData['runTime'],
                      rowData['averageTime'], rowData['percentage'])}}
                    </div>
                  </span>
                </td>
              </tr>
            </ng-template>
          </p-table>
          <h3 *ngIf="this.resource&&this.selectedLocation&&!loading&&jobs.length==0" id="noJobs"> No jobs found for this filter selection</h3>
        </div>
      </div>
    </div>
  </div>
</div>
<p-dialog [(visible)]="display" appendTo="body" color=primary header="Export to CSV" modal="true">
  <div modal="false">
    <button (click)="display =!display;dt.exportCSV();" *ngIf="loadingExport" [disabled]="enableButtons"
      label="Export This Page" pButton type="button">
    </button>
    <button (click)="exportCsv();" *ngIf="loadingExport" label="Export all {{ this.totalPages}} pages" pButton
      type="button">
    </button>
    <div *ngIf="!loadingExport">
      <p-progressBar mode="indeterminate"></p-progressBar>
      <h3>Loading Data</h3>
    </div>
  </div>
</p-dialog>
